import { HistoryReconciliation, HistoryReconciliationFilters } from "../domain/conciliator.entity";
import { conciliatorGateway } from "../domain/conciliator.gateway";

export class GetHistoryUseCase {
  constructor(private gateway: conciliatorGateway) {}

  async execute(filters: HistoryReconciliationFilters): Promise<HistoryReconciliation[]> {
    return await this.gateway.getReconciliationsHistory(filters);
  }
}
